<template>
  <div class="c-news-wrapper">
    <div class="banner">
      <img :src="banner" alt="" />
    </div>
    <div class="container">
      <h1>{{ $t("title.pressCenter") }}</h1>
      <div class="news-list">
        <ol>
          <li
            v-for="(item, index) in newsList"
            :key="index"
            @click="seeNewsDetails(item)"
          >
            <div class="img-wrap">
              <img :src="formatNewsData(item).WebSite" alt="" />
            </div>
            <h2>{{ formatNewsData(item).name }}</h2>
            <span class="add-time">{{ formatNewsData(item).AddTime }}</span>
            <div class="content">
              <div v-html="formatNewsData(item).body"></div>
            </div>
          </li>
        </ol>
        <!-- layout="prev, pager, next, jumper" -->
        <!-- @size-change="handleSizeChange" -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { formatUTC } from "@/utils/utils.js";
export default {
  data() {
    return {
      banner: "",
      newsList: [],
      pagination: {
        pageSize: 18,
        currentPage: 1,
        total: 0
      }
    };
  },
  mounted() {
    const params = {
      Data: {
        FInterID: 7
      }
    };
    this.$store.dispatch("getIndexBodyData", params).then(res => {
      console.log(res);
      this.banner = res.Data.WebSite;
    });
    this.getNewsData();
  },
  methods: {
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getNewsData();
    },
    // handleSizeChange(val) {
    //   console.log(`每页 ${val} 条`);
    // },
    seeNewsDetails(item) {
      this.$router.push({
        path: "/news-details",
        query: { id: item.FInterID }
      });
    },
    getNewsData() {
      const params = {
        Data: {
          PageSize: this.pagination.pageSize,
          PageIndex: this.pagination.currentPage
        }
      };
      this.$store.dispatch("getNewsList", params).then(res => {
        this.newsList = res.Data;
        this.pagination.total = res.TotalNumber;
      });
    },
    formatUTC(date) {
      return formatUTC(date);
    },
    formatNewsData(item) {
      let newsData = {};
      if (this.$i18n.locale === "zh") {
        newsData.body = item.jianjie;
        newsData.name = item.FName;
      } else if (this.$i18n.locale === "en") {
        newsData.body = item.Englishjianjie;
        newsData.name = item.EnglishName;
      } else if (this.$i18n.locale === "sp") {
        newsData.body = item.xibanyajianjie;
        newsData.name = item.xibanyaName;
      }
      newsData.AddTime = this.formatUTC(item.AddTime);
      newsData.WebSite = item.WebSite;
      return newsData;
    }
  }
};
</script>

<style lang="less">
@import "~@/assets/style/variables.less";
.c-news-wrapper {
  .banner {
    width: 100%;
    height: 560px;
    // background: @bgColor;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .container {
    width: 1200px;
    margin: 60px auto;

    h1 {
      font-size: 48px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 30px;
    }

    .news-list {
      ol {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        li {
          width: 384px;
          height: 375px;
          cursor: pointer;
          text-align: left;
          margin: 0 15px 60px 0;

          .img-wrap {
            width: 100%;
            height: 192px;
          }

          h2 {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(0, 0, 0, 1);
            margin: 20px 0 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 384px;
          }

          .add-time {
            display: block;
            width: 100%;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(85, 85, 85, 1);
            border-bottom: 1px solid #dcdcdc;
            padding-bottom: 10px;
            position: relative;
          }

          .add-time::before {
            content: "";
            width: 70%;
            height: 1px;
            background: #555555;
            position: absolute;
            left: 0;
            bottom: 0;
          }

          .content {
            padding-top: 20px;

            p {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 26px;
              color: rgba(85, 85, 85, 1);
              -webkit-line-clamp: 3;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        li:hover {
          h2,
          span,
          p {
            color: @bgColor;
          }

          span::before {
            background: @bgColor;
          }
        }
      }
    }
  }
}
</style>
